var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.063,
    height: 25.063,
    viewBox: "0 0 25.063 25.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7DE8\\u96C6",
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750",
    transform: "translate(-1116.909 -554.91)",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751",
    transform: "translate(1116.909 554.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    d: "M13.539,6h-8.2A2.342,2.342,0,0,0,3,8.342V24.737a2.342,2.342,0,0,0,2.342,2.342H21.737a2.342,2.342,0,0,0,2.342-2.342v-8.2",
    transform: "translate(-3 -3.516)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_4312",
    "data-name": "Path 4312",
    transform: "translate(-4.974 -2.818)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.68718814849854 18.66744804382324 L 13.62252712249756 14.92609786987305 L 24.64946365356445 3.899161100387573 C 25.02422332763672 3.524411201477051 25.52248382568359 3.318021297454834 26.05246353149414 3.318021297454834 C 26.58245468139648 3.318021297454834 27.08071327209473 3.524411201477051 27.45547485351562 3.899161100387573 C 28.22908401489258 4.672780990600586 28.22908401489258 5.931550979614258 27.45546340942383 6.705181121826172 L 16.42853736877441 17.73210716247559 L 12.68718814849854 18.66744804382324 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.05246353149414 3.818021774291992 C 25.65603446960449 3.818021774291992 25.28333282470703 3.972400665283203 25.00302505493164 4.252721786499023 L 14.07400321960449 15.18174171447754 L 13.3743724822998 17.98026275634766 L 16.17289352416992 17.28063201904297 L 27.10191345214844 6.351631164550781 C 27.68058395385742 5.772951126098633 27.68058395385742 4.831380844116211 27.10191345214844 4.252721786499023 C 26.82159423828125 3.972400665283203 26.44889450073242 3.818021774291992 26.05246353149414 3.818021774291992 M 26.05246543884277 2.818021774291992 C 26.68821334838867 2.818021774291992 27.3239631652832 3.060550689697266 27.80902481079102 3.545610427856445 C 28.77914428710938 4.515731811523438 28.77914428710938 6.088601112365723 27.80902481079102 7.058731079101562 L 16.68415451049805 18.18359184265137 L 12.00000381469727 19.3546314239502 L 13.17104339599609 14.67048072814941 L 24.29591369628906 3.545610427856445 C 24.78096771240234 3.060550689697266 25.41671752929688 2.818021774291992 26.05246543884277 2.818021774291992 Z",
    stroke: "none",
    fill: "#000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design_icon.5f25bbfd31d7bbe6e2d20173c41df929.svg";
export { ForwardRef as ReactComponent };